<template>
  <div id="documentos" class="px-2">
      <v-tabs v-model="tab">
        <v-tab>Documentos do Emitente</v-tab>
        <v-tab>Documentos da Proposta</v-tab>
      </v-tabs>
      <v-tabs-items class="mt-4" v-model="tab">
        <v-tab-item><DocumentoGrid ref="pessoaDocumento" :tipo="$aux.TipoDocumentoEntidade.Pessoa" :codigoProposta="value.Codigo" :codigoPessoa="value.CodigoCliente" :documentoCliente="value.Cliente.DocumentoFederal" hasEdit/></v-tab-item>
        <v-tab-item><DocumentoGrid ref="propostaDocumento" :tipo="$aux.TipoDocumentoEntidade.Proposta" :codigoProposta="value.Codigo" hasEdit /></v-tab-item>
      </v-tabs-items>
  </div>
</template>

<script>

export default {
  props: {
    value: null
  },
  data () {
    return {
      tab: 0
    }
  },
  methods: {
    async submit (callback) {
      let nextDocumentoProposta = true
      const th = this
      const dto = { parameters: [{ name: 'CodigoProposta', value: th.value.Codigo }] }
      await th.$api.Multiplo.ListPropostaDocumento(dto).then(function (response) {
        if (th.$api.UI.PostLoadData(response)) {
          const allDocumentsProposta = th.$param.ListaDocumentoProposta.filter(p => p.obrigatorio === true)
          if (!allDocumentsProposta.every(tipo => response.Data.some(doc => doc.TipoDocumento === tipo.value))) {
            const notDocumentos = allDocumentsProposta.filter(tipo => !response.Data.some(doc => doc.TipoDocumento === tipo.value))
            th.$api.UI.ShowError('DOCUMENTOS DA PROPOSTA', notDocumentos.map(doc => doc.text).join('<br/> '))
            nextDocumentoProposta = false
          }
        }
      })
      const obj = {
        parameters: [
          { name: 'CodigoPessoa', value: th.value.CodigoCliente },
          { name: 'CodigoProposta', value: th.value.Codigo }
        ]
      }
      let nextDocumentoEmitente = true
      await th.$api.Multiplo.ListPessoaDocumentoByDtInclusaoProposta(obj).then(function (response) {
        if (th.$api.UI.PostLoadData(response)) {
          const allDocumentsEmitente = th.$param.ListaDocumentoEmitente.filter(p => p.obrigatorio === true)
          if (!allDocumentsEmitente.every(tipo => response.Data.some(doc => doc.TipoDocumento === tipo.value))) {
            const notDocumentos = allDocumentsEmitente.filter(tipo => !response.Data.some(doc => doc.TipoDocumento === tipo.value))
            th.$api.UI.ShowError('DOCUMENTOS DO EMITENTE', notDocumentos.map(doc => doc.text).join('<br/> '))
            nextDocumentoEmitente = false
          }
          if (nextDocumentoProposta && nextDocumentoEmitente) {
            callback()
          }
        }
      })
    }
  },
}
</script>
